export default __webpack_public_path__ + "static/media/Cat_R_Rugs_V2.0a2c4949.jpeg";